import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

export const useStyles = makeStyles()((theme: Theme) => ({
  trigger: {
    width: 28,
    height: 28,
    padding: 0,
    border: 'none',
    borderRadius: 4,
    backgroundColor: theme.palette.bgSecondary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: theme.palette.labraText.description,
    '& svg': {
      fontSize: 16,
    },
  },
  paper: {
    marginTop: 8,
    borderRadius: 8,
    backgroundColor: theme.palette.common.white,
    boxShadow:
      '0px 2px 6px 2px rgba(0,0,0,0.15), 0px 1px 2px 0px rgba(0,0,0,0.3)',
  },
  panel: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    padding: '8px 0',
    minWidth: 300,
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 24px',
  },
  option: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '8px 16px 8px 32px',
    cursor: 'pointer',
  },
  radio: {
    padding: 0,
    color: theme.palette.labraText.description,
    '&.Mui-checked': {
      color: theme.palette.labraText.tertiary,
    },
    '& svg': {
      fontSize: 22,
    },
  },
  optionLabel: {
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: '0.5px',
    color: theme.palette.labraText.tertiary,
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: theme.palette.labraText.tertiary,
  },
  caret: {
    fontSize: 16,
    color: theme.palette.labraText.description,
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    gap: 24,
    padding: '16px 24px',
  },
  linkButton: {
    border: 'none',
    background: 'none',
    padding: 0,
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: theme.palette.icon.blue,
  },
}))
